import { Link } from "react-router-dom";
import SiteNav from "@/components/feature/SiteNav";
import SiteFooter from "@/components/feature/SiteFooter";
import PageHeader from "@/components/feature/PageHeader";
import StartProjectCTA from "@/components/feature/StartProjectCTA";
import { projects } from "@/mocks/projects";

export default function ProjectsIndex() {
  return (
    <div className="min-h-screen bg-warm-bg text-ink">
      <SiteNav />
      <PageHeader
        eyebrow="Selected Work"
        title={<>Projects, resolved quietly.</>}
        intro="A selection of recent residential renovations across Southern California — whole homes, kitchens, bathrooms and additions."
        crumbs={[{ label: "Home", to: "/" }, { label: "Projects" }]}
      />
      <section className="w-full pb-24">
        <div className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
            {projects.map((p) => (
              <Link key={p.slug} to={`/projects/${p.slug}`}
                    className="group cursor-pointer block [&_.meta]:px-[clamp(20px,5vw,96px)]">
                <div className="overflow-hidden">
                  <img src={p.image} alt={p.title}
                       className="w-full block transition-transform duration-700 group-hover:scale-[1.02]"
                       style={{ aspectRatio: "4/3", objectFit: "cover" }} />
                </div>
                <div className="meta mt-6 mb-16 flex items-start justify-between gap-6">
                  <div>
                    <span className="eyebrow">{p.num} — {p.category}</span>
                    <h3 className="mt-3 font-serif-display font-light leading-[1.1]"
                        style={{ fontSize: "clamp(24px,2vw,30px)", letterSpacing: "-0.015em" }}>
                      {p.title}
                    </h3>
                    <div className="mt-2 text-ink-soft" style={{ fontSize: "13px" }}>
                      {p.location} · {p.year}
                    </div>
                  </div>
                  <i className="ri-arrow-right-up-line text-ink w-6 h-6 flex items-center justify-center group-hover:text-accent transition-colors" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <StartProjectCTA />
      <SiteFooter />
    </div>
  );
}